import { restActionCreatorHelper } from './../../helpers/restActionCreatorHelper';

const appSettingsRestAction = restActionCreatorHelper(`appSettings`);

export const ExampleRestActions = appSettingsRestAction('example');